var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(!_vm.isReady)?_c('loader'):_vm._e(),(_vm.isReady)?_c("main-layout",{tag:"component"},[_c('router-view')],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }